import * as React from "react";
import { GenericModal } from "./GenericModal";
import { CenteredModal } from "./CenteredModal";
import { ContainerModal } from "./ContainerModal";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
import { jsx as ___EmotionJSX } from "@emotion/core";
var Modal = function Modal(props) {
  return ___EmotionJSX(GenericModal, props);
};
Modal.Centered = CenteredModal;
Modal.Container = ContainerModal;
export { Modal };
export { ModalCloseButton } from "./ModalCloseButton";